<template>
  <section class="recap-cover full" v-scroll-nav="{ path: '/value/cover', onEnter: createGraph }">
    <div class="row wrapper">
      <div class="col pad info">
        <div class="headline">
          <p v-animate-in="{ delay: 1 }">
            {{ $t('value-total-for-year', { year: $config.year }) }}
          </p>
          <h2 v-animate-in><NumberTween :value="totalFromActivities" /></h2>
          <CTA
            :cta="$t('cta-calculate')"
            @click.native="toggleDetails(true)"
            v-animate-in="{ delay: 0.55 }"
          />
        </div>
        <div class="links">
          <CTA
            :cta="$t('value-history50-label')"
            @click.native="toggleHistory50(true)"
            v-animate-in="{ delay: 0.75 }"
          />
        </div>
      </div>
      <div class="graph-container">
        <AreaGraph
          ref="graph"
          class="graph"
          :data="nestedActivities"
          v-if="nestedActivities.length"
          :tilt="2"
          progressive
          show-labels
          @select="goToSection"
          :holes="1"
        />
      </div>
    </div>

    <Aside :active="showDetails" @close="toggleDetails(false)">
      <Calculate />
    </Aside>
    <Aside :full="true" :active="showHistory50" @close="toggleHistory50(false)" inverted>
      <History50 v-if="showHistory50" />
    </Aside>
  </section>
</template>

<script>
import Aside from '@/components/common/Aside';
import AreaGraph from '@/components/common/graphs/AreaGraph';
import CTA from '@/components/common/CTA';
import NumberTween from '@/components/common/NumberTween';
import History50 from '@/components/value/History50';
import Calculate from '@/components/value/Calculate';

export default {
  components: { Calculate, Aside, CTA, AreaGraph, NumberTween, History50 },
  data() {
    return {
      showHistory50: false,
      showDetails: false
    };
  },
  watch: {
    $route(to) {
      if (!to.path.includes('details')) {
        this.toggleDetails(false, false);
      }
      if (!to.path.includes('history50')) {
        this.toggleHistory50(false, false);
      }
    }
  },
  computed: {
    activities() {
      return this.$store.getters['activities/list'];
    },
    totalFromActivities() {
      return this.activities.reduce((acc, curr) => {
        return acc + curr.value;
      }, 0);
    },
    nestedActivities() {
      return this.activities.map(a => ({
        name: a.id,
        color: a.color,
        value: a.value,
        label: `${this.$options.filters.currencyShort(a.value)}<br />
        <span class="tx-cta">${a.title[this.$i18n.locale]}</span>`,
        parent: 'origin'
      }));
    }
  },
  methods: {
    goToSection(section) {
      this.$router.push('/value/' + section.name);
    },
    createGraph() {
      if (this.$refs.graph) this.$refs.graph.next();
    },
    toggleDetails(val, nav = true) {
      this.showDetails = val;
      if (val) this.$router.push({ path: `/value/cover/details` });
      else if (nav) this.$router.go(-1);
    },
    toggleHistory50(val, nav = true) {
      this.showHistory50 = val;
      if (val) this.$router.push({ path: `/value/cover/history50` });
      else if (nav) this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.recap-cover {
  background-color: $col-navy-dark;
  .row {
    position: relative;
    width: 100%;
    height: 100%;
    &.wrapper {
      overflow: hidden;
    }
  }
  .graph-container {
    z-index: 1;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 50%;
    height: 100%;
    padding-top: $padding;
    @media screen and (max-width: $mq-tablet) {
      padding-top: $padding/4;
      height: 50%;
      width: 100%;
    }
  }
  .info {
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    position: absolute;
    height: 100%;
    pointer-events: none;
    @media screen and (max-width: $mq-tablet) {
      height: 100%;
      justify-content: inherit;
      padding-top: $padding/2;
    }
    .headline {
      pointer-events: all;
      h2 {
        margin-top: $padding/4;
        margin-bottom: $padding;
        @media screen and (max-width: $mq-tablet) {
          margin-top: $padding/6;
          margin-bottom: $padding/4;
        }
      }
    }
    .links {
      pointer-events: all;
      margin-top: 4rem;
      @media screen and (max-width: $mq-tablet) {
        margin-top: 2rem;
      }
      @media screen and (max-width: $mq-mobile) {
        margin-top: 0.5rem;
      }
    }
    .cta {
      margin-bottom: $padding/6;
    }
  }
}
</style>
